export default "__VITE_ASSET__BKz0KWdX__"